export default "__VITE_ASSET__267a1f41__"